import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-deep px-4 pb-28 pt-4 sm:px-6 sm:pb-32" data-id="element-180" data-mp="19j53j40hsmi0">
      <div className="mx-auto max-w-2xl border-t border-white/10 pt-6 text-center" data-id="element-181" data-mp="206j6dqqc6pi3">
        <p className="text-[12.5px] font-semibold text-white/60" data-id="element-182" data-mp="2f53fjo5x71jx">
          Il Sistema Maestro di Pianificazione con Allineatori™ © 2026. Tutti i diritti riservati.
        </p>
        <p className="mt-3 text-[11.5px] leading-relaxed text-white/40" data-id="element-183" data-mp="1mfwfuluqc5x3">
          Questo materiale è una risorsa educativa. Le decisioni terapeutiche devono sempre basarsi sul giudizio
          professionale del clinico, sulle caratteristiche specifiche del paziente, sugli standard di cura applicabili e
          su un’adeguata formazione clinica.
        </p>
      </div>
    </footer>;
}